<div class="">
  <ng-container *ngIf="conversationDetails" >
    <h3>{{ conversationDetails[0]?.emailDetails?.Subject }}</h3>
    <div *ngFor="let conversation of conversationDetails; let i = index" class="card my-2 p-2">
        <div class="row m-0" (click)="toggleMultiEmail(i, conversation)">
          <div class="col-12 p-0 d-flex align-items-start justify-content-between email-wrap" style="overflow-x: hidden;">
            <div class="col-8 p-0" *ngIf="conversationDetails.length-1>i && !conversation.isExpanded?true:null">
              <div *ngIf="emailDetails?.From">
                <strong>{{ conversation.emailDetails?.From }}</strong>
              </div>
              <small class="mt-0" [innerHtml]="conversation.emailDetails.shortSnippet | keepHtml"></small>
            </div>
            <div class="col-8 p-0" [hidden]="i!==conversationDetails.length-1 && !conversation.isExpanded?true:null">
              <div *ngIf="emailDetails?.From">
                <strong>From: </strong>
                <strong>{{ conversation.emailDetails?.From }}</strong>
                {{conversation.emailDetails?.Date | date : "MM/dd/yyyy h:mm a"}}
              </div>
               <div class="d-flex flex-wrap">
                <div *ngIf="emailDetails?.To">
                  <span class="toccDiv">To: </span>
                  <span class="toccDiv">{{conversation.emailDetails?.To}}</span>
                </div>
                <div *ngIf="emailDetails?.Cc">
                  <span class="toccDiv">CC: </span>
                  <span class="toccDiv">{{conversation.emailDetails?.Cc}}</span>
                </div>
               </div>
            </div>
            <nav class="navbar navbar-expand-lg navbar-light py-0" style="background-color: transparent !important;">
              <button
                class="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#mailNav"
                aria-controls="mailNav"
                aria-expanded="false"
                aria-label="mailNav navigation"
              >
                <span class="navbar-toggler-icon"></span>
              </button>
              <div class="collapse navbar-collapse d-flex p-justify-end align-items-end" id="mailNav">
                <form class="form-inline my-2 my-lg-0">
                  <button
                    class="btn p-0 mr-2 my-sm-0"
                    (click)="onBack()"
                    type="button"
                  >
                    <i aria-hidden="true" title="Back" class="fa fa-chevron-circle-left mr-2"></i>
                  </button>
                  <button
                    class="btn p-0 mr-2 my-sm-0"
                    (click)="onReplyChange('forward',conversation.emailDetails?.id)"
                    type="button"
                  >
                    <i aria-hidden="true" title="Forward" class="fa fa-rotate-right mr-2"></i>
                  </button>
                  <button
                    class="btn p-0 mr-2 my-sm-0"
                    (click)="onReplyChange('replyAll',conversation.emailDetails?.id)"
                    type="button"
                  >
                    <i aria-hidden="true" title="Reply All" class="fa fa-reply-all mr-2"></i>
                  </button>
                  <button
                    class="btn p-0 mr-2 my-sm-0"
                    (click)="onReplyChange('reply',conversation.emailDetails?.id)"
                    type="button"
                  >
                    <i aria-hidden="true" title="Reply" class="fa fa-reply mr-2"></i>
                  </button>
                  <button
                    class="btn p-0 mr-2 my-sm-0"
                    (click)="deleteEmail(conversation.emailDetails?.id, i)"
                    type="button"
                  >
                    <i aria-hidden="true" title="Delete" class="fa fa-trash mr-2"></i>
                  </button>
                </form>
              </div>
            </nav>
          </div>
        </div>
        <div class="row m-0"  [hidden]="i!==conversationDetails.length-1 && !conversation.isExpanded?true:null">
          <!-- later decide To or From based on emailType -->
        <hr class="detail_hr">
          <div class="col-12 p-0">
            <div class="mt-0" [innerHtml]="conversation.emailDetails.snippet | keepHtml"></div>
            <div *ngIf="conversation.attachments.length">
              {{ conversation.attachments.length }} Downloads
            </div>
            <div class="d-flex flex-wrap">
              <div class="downloads" *ngFor="let download of conversation.attachments">
                <a (click)="onDownloadClick(download)">{{
                  download.filename
                }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      </ng-container>
</div>